// extracted by css-extract-rspack-plugin
export default {"cls1":"AccountMenu-cls1_BkO","cls2":"AccountMenu-cls2_NHQ AccountMenu-cls1_BkO"};